/** Single source of truth for company details used across the page. */
export const site = {
  name: 'Aerospace Design and Consulting Services (Pty) Ltd',
  shortName: 'ADCS',
  url: 'https://www.aerospace-dcs.com/',
  registration: '2019/626715/07',
  email: 'yashren.reddi@aerospace-dcs.com',
  phone: '+27 72 644 8444',
  phoneHref: '+27726448444',
  location: 'Cape Town, South Africa',
  copyrightYear: 2026,
  /** Engineering domains and platforms represented in the team's experience. */
  industries: [
    'Satellite systems',
    'Unmanned aircraft',
    'Cloud computing',
    'Semiconductor lithography',
    'Electric vehicles',
    'Industrial robotics',
    'Radio astronomy',
    'Embedded Linux',
  ],
  professionalExperience: [
    'Denel',
    'Amazon Web Services (AWS)',
    'ASML',
    'CubeSpace',
    'Lightyear',
    'Lely',
    'SKAO',
  ],
  principal: {
    name: 'Dr Yashren Reddi',
    role: 'Founder & Principal Engineer',
    // credential: 'PhD in Control Systems Engineering',
    // focus: 'Robust multivariable control · Satellite AOCS · Flight software',
  },
} as const;
